module.exports = __webpack_public_path__ + "static/media/How-To-Fix-Catalytic-Converter-Without-Replacing.efff920b.jpg";